import {deserializePremiumSermon, SerializedPremiumSermon} from "../../src/entities/PremiumSermon";
import { WebClient } from "./server/WebClient";

export interface SavePremiumSermonRequest {
	id?: number;
	title: string;
	shortDescription: string;
	description: string;
	thumbnail?: string;
}

export interface SavePremiumSermonAssetRequest {
	premiumId: number;
	assetId: string;
}

export const PremiumSermonService = {
	getAll: () => WebClient.Get("api/PremiumSermon/GetPremiumSermon", (sermons:SerializedPremiumSermon[]) => sermons.map(deserializePremiumSermon)),
	getAllEnabled: () => WebClient.Get("api/PremiumSermon/GetEnabledPremiumSermon", (sermons:SerializedPremiumSermon[]) => sermons.map(deserializePremiumSermon)),
	get: (id: number) => WebClient.Get(`api/PremiumSermon/GetPremiumSermon/${id}`, deserializePremiumSermon),
	getByName: (name: string) => WebClient.Post.Unvalidated(`api/PremiumSermon/GetPremiumSermonByTitle`, { title: name} , deserializePremiumSermon),
	purchase: (id: number) => WebClient.Put.Validated(`api/PremiumSermon/Purchase/`, { id }),
	activate: (id: number) => WebClient.Post.Validated<string>(`api/PremiumSermon/Activate/`, {PremiumSermonId: id})
}
